module.exports = __webpack_public_path__ + "media/2-31.37587a62.wav";